import { Utilities as utilities } from "@truckdown/framework";

export class ThrottleCounts {
    constructor(json?: any) {
        if (json) {
            this.throttle = utilities.json.getStringValue(json, 'throttle', '');
            this.timedCount = utilities.json.getNumberValue(json, 'time', 0);
            this.fiveCount = utilities.json.getNumberValue(json, 'five', 0);
            this.hourCount = utilities.json.getNumberValue(json, 'hour', 0);
            this.dayCount = utilities.json.getNumberValue(json, 'day', 0);
            this.totalTimedCount = utilities.json.getNumberValue(json, 'totTime', 0);
            this.totalFiveCount = utilities.json.getNumberValue(json, 'totFive', 0);
            this.totalHourCount = utilities.json.getNumberValue(json, 'totHour', 0);
            this.totalDayCount = utilities.json.getNumberValue(json, 'totDay', 0);

            if (json.ratio) {
                this.ratioCounts = utilities.json.getObjectValue(json,
                    (itm) => { return new ThrottleCounts(itm); }, 'ratio')
                    ?? new ThrottleCounts();
            }
        }
    }

    toJSON() {
        return {
            throttle: this.throttle,
            time: this.timedCount,
            five: this.fiveCount,
            hour: this.hourCount,
            day: this.dayCount,
            totTime: this.totalTimedCount,
            totFive: this.totalFiveCount,
            totHour: this.totalHourCount,
            totDay: this.totalDayCount,
            ratio: this.ratioCounts
        };
    }

    throttle: string = '';

    timedCount: number = 0;
    fiveCount: number = 0;
    hourCount: number = 0;
    dayCount: number = 0;
    totalTimedCount: number = 0;
    totalFiveCount: number = 0;
    totalHourCount: number = 0;
    totalDayCount: number = 0;

    ratioCounts?: ThrottleCounts;
}